<template>
    <div id="coverage-chart" >
        <div id="title">
            <!-- Title according to Packs or Products -->

            <!-- PAQUETES, EXTRA-PRODUCTS RC - need to know the IndexDetail  -->
            <header v-if="dataTable.length > 1" class="vs-popup--header" id="main_titles" >
                <table class="vx-row w-full">
                    <tr class="w-full"><img :id="changeImageId(dataTable[1].packIndex)" style="float:center;" src="../../../../assets/images/pages/eCommerce/umbrella.png"/></tr>
                    <tr class="w-full mt-4 mb-4" style="text-align:center;"><p class="packName">{{dataTable[0].name}} </p></tr>
                    <tr class="w-full mb-2" style="text-align:center;">
                        <span class="packPrima">{{decimalNumberWithCommas(dataTable[0].receipt.toFixed(2))}}</span>
                        <span class="packUnits"> €/{{getPaymentMethod(dataTable[1].paymentMethod)}}</span>
                        <!-- <span class="packUnits"> €/{{getPaymentMethod(commercialOffer.paymentMethod)}}</span> -->
                        <!-- // dataTable[0] -->
                    </tr>
                </table>
            </header>

            <!-- LIBRE - no need to know the IndexDetail -->
            <header v-if="dataTable.length <= 1" class="vs-popup--header" id="main_titles" >
                <table class="vx-row w-full">
                    <tr class="w-full"><img class="image" style="float:center;" src="../../../../assets/images/pages/eCommerce/umbrella.png"/></tr>
                    <tr class="w-full mt-4 mb-4" style="text-align:center;"><p class="packName">{{dataTable[0].name}} </p></tr>
                    <tr class="w-full mb-2" style="text-align:center;">
                        <span class="packPrima">{{dataTable[0].receipt.toFixed(2).replace('.',',')}}</span>
                        <span class="packUnits" style="font-weight:bold"> €/{{getPaymentMethod(dataTable[0].paymentMethod)}}</span>
                    </tr>
                </table>
            </header>
        </div>

        <div id="table">
            <vs-table :data="coverageChart.capitalOffer" class="table-dark-inverted">
                <template slot-scope="{ data }">
                    <vs-tr id="titles" >
                        <div id="covers_label" class="pb-1 pl-50" style="float:left; font-weight:bold">
                            <span> Prestaciones </span>
                        </div>
                        <div id="capital_label" class="pb-1" style="float:right; padding-right:20px; font-weight:bold">
                            <span> Capital</span>
                        </div>

                    </vs-tr>

                    <vs-tr class="mt-1 align" style="display:table-row; width:100%"  :key="indextr" v-for="(tr, indextr) in data" >
                        <!-- <vs-td class="bullet-points"></vs-td> -->
                        <li>
                            <vs-td :data="data[indextr].cover" class=" py-1 categoryName" style="display:inline-flex">
                                {{data[indextr].cover}}
                            </vs-td>

                        <vs-td class=" py-1 categoryCapital" style="display:inline; float:right;" v-if="data[indextr].capital > 1" :data="data[indextr].capital" >
                            {{formatImporte(data[indextr].capital)}}
                        </vs-td>
                        <vs-td class=" py-1 categoryCapital" style="display:inline; float:right;" v-if="data[indextr].addedLiteral">
                            {{data[indextr].addedLiteral}}
                        </vs-td>
                        <vs-td class=" py-1 categoryCapital" style="display:inline; float:right;" v-if="data[indextr].capital == 1 &&  data[indextr].addedLiteral == ''">
                            Incluido
                        </vs-td>
                        </li>

                    </vs-tr>
                </template>
            </vs-table>
            <!--  -->
        </div>
        <div class="squared-button right-button-popup" >
            <vs-button
            @click="goToThirdStep()"
            >
                Me interesa</vs-button>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
export default {
  components: { VxCard },

    name: 'coverage-chart',
    props: {
        coverageChart: Object,
        dataTable: Array,
        coverageChartPop: Boolean,
    },
    data() {
        return {
            offerCalculatedResponse: null,
            index: null,
        }
    },
    created() {
        const backButtonRouteGuard = this.$router.beforeEach(async (to, from, next) => {
        //   console.log(from)
          if (this.coverageChartPop) {
            /* Blocking back button in menu route */
             
            next( await this.closeCoverageChartPop());
          } else {
            /* allowing all other routes*/
            next(true);
          }
        });

    },
    methods: {
        formatImporte(importe){
            if(!isNaN(importe)){
               return importe.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")  + ' €'
            // return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe).replace(/\D00(?=\D*$)/, '');
            // return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe.toFixed(2));
            }
            return importe;
        },
        async closeCoverageChartPop(){ 
            //this.coverageChartPop = false;
            let response = {
                closePop: false,
                packName: ""
            }
            this.$emit("closeCoverageChartPop", response)
        },
        goToThirdStep() {
            //this.coverageChartPop = false;
            let response = {
                closePop: false,
                packName: this.coverageChart.name
            }
            this.$emit("closeCoverageChartPop", response)
        },
        changeImageId(indexDetail){
          return 'image-'+indexDetail
        },
        getPaymentMethod(payment){
           let paymentMethod = ""
           switch(payment){
               case 1:
                   paymentMethod = "año"
                break;

               case 2:
                paymentMethod = "semestre"
                break;

               case 3:
                paymentMethod = "cuatrimestre"
                break;

               case 4:
                paymentMethod = "trimestre"
                break;

               case 6:
                paymentMethod = "bimensual"
                break;

               case 12:
                paymentMethod = "mes"
                break;
           }
           return paymentMethod
       },
        decimalNumberWithCommas(number) {
          if(number){
            let decimalCommaNumber = number.replace('.',',')
            return decimalCommaNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          }
        },
    },
}
</script>

<style lang="scss">

#coverage-chart {

    header#main-titles{
     margin-top: 0px;

        td {
            text-align: center;
            vertical-align: middle;
        }
    }

    .image {
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
    }

   #image-0 {
        width: 50px;
        height: 50px;
        display:block;
        margin:auto;
     }
    #image-1 {
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
    }
    #image-2 {
        width: 70px;
        height: 70px;
        display:block;
        margin:auto;
    }


    .packName{
        line-height: 12px !important;
        font-weight: 530;
        font-size: 17px;
        display:block;
        margin:auto;
    }

    .align{
        display: flex;
        align-items: center !important;
        justify-content: space-between;
    }

    // To delete background colour in popup
    .vs-con-table .vs-con-tbody{
            border-color: white !important;
            background: white !important;
        }

}


.con-vs-popup {
    .vs-popup--content {
        padding-top: 0px;
        margin-top:0px !important;
    }
}

.coverage-popup{
    // :makeTitle deleted to write here title & display image
    .vs-popup--title {
        display: none;
    }

    .vs-popup--header {
        background: none !important;
        justify-content: flex-end !important;
    }
}

// To delete click effects on popup categories
.vs-table--tbody-table .tr-values{
    -webkit-transform: none !important;
    transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
    padding-top: 2px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
}


@media only screen and (max-width: 650px) {
    .vs-table--tbody-table {
        min-width: 250px;
    }

    .categoryName{
        max-width: 60%;
        overflow-wrap: break-word !important;
    }
    .categoryCapital{
        max-width: 30%;
        white-space:nowrap;
    }

    .move-right{
        margin-right: 0px !important;
        div{
            padding-right:0px;
        }
    }

 }

 @media only screen and (min-width: 651px) {
    .vs-table--tbody-table {
        min-width: 250px;
    }

    .categoryName{
        max-width: 75%;
        overflow-wrap: break-word !important;
    }
    .categoryCapital{
        max-width: 30%;
        white-space:nowrap;
    }

    .move-right{
        margin-right: 0px !important;
        div{
            padding-right:0px;
        }
    }

 }
</style>